<template>
    <div class="main-panel" id="fileupload" >
      <div class="readOnly">本demo仅作为功能演示，不提供实际的在线文档服务。</div>
        <div class="clearFix">
            <div class="header">
                <!--        上传文档-->
                <div class="upload-panel clearFix">
                    <div class="file-upload-title">本地上传</div>
                    <div class="flex-center vertical-line">
                        <div class="file-upload">上传文件
                            <input type="file"  @change="onUploadFile"/>
                        </div>
                    </div>
                    <div class="error" v-if="errors.length">
                        <ul>
                            <li v-for="error in errors" v-bind:key="error.index">{{ error }}</li>
                        </ul>
                    </div>
                </div>
                <!--        新建文档-->
                <div class="create-panel clearFix">
                    <div class="create-title">新建文件
                        <div class="create-desc">配置方式</div>
                    </div>
                    <ul class="try-editor-list clearFix">
                        <li @click="onOpenNewEditor('docx')">
                            <div class="try-editor document reload-page">新建文字处理</div>
                        </li>
                        <li @click="onOpenNewEditor('xlsx')">
                            <div class="try-editor spreadsheet reload-page">新建电子表格</div>
                        </li>
                        <li @click="onOpenNewEditor('pptx')">
                            <div class="try-editor presentation reload-page">新建演示文稿</div>
                        </li>
                        <li @click="onOpenNewEditor('docx', true)">
                            <div class="try-editor content reload-page">新建含内容域文件</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="textExamples">
          <div class="stored-list-title">应用场景</div>
          <div class="textContainer">
            <div class="text-center">
              <div class="box-top">
                <div class="box-title">文档内容快速填充</div>
                <div class="box-content">在合同、标书等文档制作过程中，实现文档指定区域的内容填充</div>
              </div>
              <div class="box-bottom" @click.stop="openQuick('docx')">
<!--                <div><img alt="" src="/examples/static/media/content-control.0c706ab48d5d95b7b02a.gif" data-set="/examples/static/media/content-control.0c706ab48d5d95b7b02a.gif"></div>-->
                <div class="box-bottom-content">
                  <div class="box-action" @click.stop="openQuick('docx')"><i class="el-icon-caret-right"></i>运行</div>
                  <a class="a-download box-action" :href="downloadUrl" @click.stop="downloadUrl = '../../static/ContentControl.zip'" download="内容控件示例.zip">
                    <i class="el-icon-download"></i>下载源代码
                  </a>
                </div>
              </div>
            </div>
<!--            <div class="text-center">-->
<!--              <div class="box-top">-->
<!--                <div class="box-title">文档定稿一键清稿</div>-->
<!--                <div class="box-content">在文档定稿时，一键接受所有审阅修订，删除所有审阅批注，生成清洁版本的文档</div>-->
<!--              </div>-->
<!--              <div class="box-bottom">-->
<!--                &lt;!&ndash;                <div><img alt="" src="/examples/static/media/content-control.0c706ab48d5d95b7b02a.gif" data-set="/examples/static/media/content-control.0c706ab48d5d95b7b02a.gif"></div>&ndash;&gt;-->
<!--                <div class="box-bottom-content">-->
<!--                  <div class="box-action" @click="oneKeyClear('docx')"><span><i class="el-icon-caret-right"></i>运行</span></div>-->
<!--                  <div class="box-action"><a class="a-download" href="../../static/ContentControl.zip" download="内容控件示例.zip">-->
<!--                    <span><i class="el-icon-download"></i>下载源码</span></a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="text-center"></div>
          </div>
        </div>

        <div class="stored-list">
          <div class="stored-list-title">初始化配置</div>
          <table class="stored-list-container ">
            <!--表头-->
            <thead>
              <tr class="tableHeader line">
                <th class="tableHeaderCell tableHeader-switch">用户名</th>
                <th class="tableHeaderCell tableHeaderCellFileName">文件名称</th>
                <th class="tableHeaderCell tableHeaderCellView">视图控制</th>
                <th class="tableHeaderCell tablePadding" >权限控制</th>
                <th class="tableHeaderCell tablePadding" >协作模式</th>
                <th class="tableHeaderCell tableHeaderCode">源码</th>
              </tr>
            </thead>
            <file-list v-bind:fileLists="fileLists"
                       v-bind:config="config"
                       v-on:onDelete="propsDelete"></file-list>

          </table>

          <div class="page-nocont" v-show="fileLists.length==0">
            <div class="nocont-inner">
              <i class="nocont-img"></i>
              <div class="nocont-desc">请上传本地文件或新建文件</div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/home.css";
    import FileList from "../components/fileList";
    import axios from 'axios'

    export default {
        name: 'home',
        components: {FileList},
        props:['config'],
        data: function() {
            return {
                baseUrl: config.baseUrl,
                params: '',
                errors: [],
                preloaderUrl: '',
                convertExts: '',
                editedExts: '',
                viewExts:'',
                storedFiles: [],
                fileLists: [],
                fileName: '',
                fileExt: '',
                editorMode: 'edit',
                // openedExts: ['docx', 'xlsx', 'pptx'],
                allowEditedExts: [],
                allowConvertExts: [],
             //   allowviewedExts: [],
                defaultConfig: {
                    userId: 'uid-1',
                    userName: '张婷平',
                    lang: 'zh',
                    mode: 'edit',
                },
                selectSample: false,
                permission: {
                    comment: false,
                    edit: false,
                    review: false,
                    print: false,
                    download: false,
                    copyoutenabled: false,
                },
                customization: {
                    leftMenu: true,
                    rightMenu: true,
                    statusBar: true,
                    header: true,
                },

              selectUser: {
                name: '张婷平',
                id: 'uid-1'
              },
              selectUserId: 'uid-1',
              selectUserName: '张婷平',
              selectMode: 'desktop',
              selectReviewDisplay: 'markup',
              permissionCheckList: [],
              viewCtrlCheckList: ['工具栏', '左侧面板', '状态栏', '右侧面板',],
              // fileName: '',
              fileType: '',
              downloadUrl:'../../static/ContentControl.zip',//下载zip地址
            }
        },
        created() {
            // log("this.config",this.config)
            log("this.baseUrlkkkkkk", this.baseUrl)

            // 从后台获取数据
            axios.get(this.baseUrl + '/all').then(r => {
                var res = r.data;
              log("all data:", res)
                this.storedFiles = res.storedFiles;
                this.preloaderUrl = res.preloaderUrl;
                this.convertExts = res.convertExts;
                this.editedExts = res.editedExts;
                this.viewExts = res.viewExts;
                this.params = res.params;
                this.cleanData(res);
                this.init();

            })
            // this.selectUserName = this.userLists[0].name;

        },
        updated() {
            // log("this.customization", this.customization)
        },

        methods: {
          openQuick(type, sample = true) {
            // this.fileName = 'muban.docx';
            // var docKey = '1555555';
            var docKey = Math.random().toString(36).slice(-11);

            this.fileType = type;
            let query = {
              // mode: this.editorMode,
              fileExt: 'docx',
              sample: sample,
              // key:docKey,
              // docUrl:'info/simple.docx',

              showLeftBar: false,
              showQuickBar: true,
              showContract: true,
              showOneKeyClear: false,

              mode: this.selectMode,
              reviewDisplay: this.selectReviewDisplay,
              fileName: this.fileName,
              fileType: this.fileType,
              userid: this.selectUser.id,
              name: this.selectUser.name,
              lang: this.selectlang,

              compareWithUrl:this.customization.compareWithUrl,
              isCompareWithUrl:this.customization.isCompareWithUrl,
              leftMenu: false,
              rightMenu: false,
              statusBar: this.viewCtrlCheckList.indexOf('状态栏') > -1,
              toolbar: this.viewCtrlCheckList.indexOf('工具栏') > -1,
              download: !(this.permissionCheckList.indexOf('禁止下载') > -1),
              print: true,
              copyoutenabled: false,
            }
            // log("this.fileName, this.fileType", this.fileName, this.fileType)
            // log("query in file item", query)
            var routeData = this.$router.resolve({
              path: "/editor",
              query: query
            });

            window.open(routeData.href, "_blank");
            setTimeout(function () {
              document.location.reload();
            }, 100)
            // axios.post(this.baseUrl + '/updateBin',{key:docKey}).then(res => {
            //   if (res.status == 200) {
            //
            //   } else {
            //     console.log(res);
            //     console.log(config.serverUrl)
            //   }
            // })
          },
          //文档定稿一键清稿
          oneKeyClear(type, sample = false) {
            this.fileName = 'dongshihuimuban.docx';
            this.fileType = type;
            let query = {
              // mode: this.editorMode,

              showLeftBar: false,
              showQuickBar: true,
              showContract: false,
              showOneKeyClear: true,

              mode: this.selectMode,
              reviewDisplay: this.selectReviewDisplay,
              fileName: this.fileName,
              fileType: this.fileType,
              userid: this.selectUser.id,
              name: this.selectUser.name,
              lang: this.selectlang,

              compareWithUrl:this.customization.compareWithUrl,
              isCompareWithUrl:this.customization.isCompareWithUrl,
              leftMenu: true,
              rightMenu: false,
              statusBar: this.viewCtrlCheckList.indexOf('状态栏') > -1,
              toolbar: this.viewCtrlCheckList.indexOf('工具栏') > -1,
              download: !(this.permissionCheckList.indexOf('禁止下载') > -1),
              print: false,
              copyoutenabled: false,
            }
            // log("this.fileName, this.fileType", this.fileName, this.fileType)
            // log("query in file item", query)
            var routeData = this.$router.resolve({
              path: "/editor",
              query: query
            });

            window.open(routeData.href, "_blank");
            // setTimeout(function () {
            //   document.location.reload();
            // }, 1000)
          },

          cleanData: function (res) {
                this.allowEditedExts = res.editedExts.split(",");
            this.allowConvertExts = res.convertExts.split(",");
         //   this.allowviewedExts = res.viewExts.split(",");
                // 生成文件列表对象
                var files = res.storedFiles;
                // log("files", files)
                let keys = Object.keys(files)
                for (let i = 0; i < keys.length; i++) {
                    var o = {};
                    var file = files[i];
                    o.name = file.name;
                    o.type = file.documentType;
                    this.fileLists.push(o);
                }
          },
          onUploadFile: function (e) {
              var file = e.target.files[0];
              // console.log("上传的文件：", file)
              if (file) {
                  this.handleUpload(file);
              }
          },
          downloadFile(data, fileName) {
            var blob = new Blob([data], { type: 'application/octet-stream' });
            var url = URL.createObjectURL(blob);

            var link = document.createElement('a');
            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          },
          //下载源码zip
          downloadZip() {
            var fileData = '这是文件的内容';
            var fileName = 'example.txt';
            this.downloadFile(fileData, fileName);
          },
          handleUpload: function (file) {
              var fileType = file.name.substring(file.name.lastIndexOf("."));
              var size = file.size;
              var isAllowUp = this.allowConvertExts.indexOf(fileType);
              var isAllowEdit = this.allowEditedExts.indexOf(fileType);

                var upload = document.getElementById("fileupload");
                // 文件格式和大小拦截
                // 浏览器拦截

                this.errors=[];
                if (size <= 0 || size > 1073741824) {
                    this.errors.push('提示：上传的文件大小不支持！');
                    upload.value = '';
                    return;
                }
                // else if (isAllowUp < 0 && isAllowEdit<0) {
                //     this.errors.push('提示：上传的文件格式不支持！');
                //     upload.value = '';
                //     return;
                // }
                else {
                    // 发送文件到后台
                    // var urlPath = window.document.location.host;    //浏览器显示地址
                    var data = new FormData();
                    data.append('file', file);
                    axios.post(this.baseUrl + '/upload', data, {
                        headers: { 'content-type': 'multipart/form-data' }
                    }).then(r => {
                        log("res", r.data)
                        var res = r.data;
                        if (res.error) {
                            this.errors.push(res.error);
                            upload.value = '';
                            return;
                        } else if (res.documentType && res.filename) {
                            var o = {};
                            o.type = res.documentType;
                            o.name = res.filename;
                            this.fileLists = [].concat(o, this.fileLists);
                            // this.fileLists.push(o)
                            upload.value = '';
                        }
                        // this.docurl ="http://" + urlPath + res.path;
                        }
                    );
                }
            },
          // onOpenFile: function (f) {
            //     this.fileName = f;
            //     var routeData = this.$router.resolve({
            //         path: "/editor",
            //         query: {
            //             mode: this.editorMode,
            //             fileName: this.fileName,
            //             userid: this.selectUserId,
            //             name: this.selectUserName,
            //             lang: this.selectlang,
            //             leftMenu: this.customization.leftMenu,
            //             rightMenu: this.customization.rightMenu,
            //             statusBar: this.customization.statusBar,
            //             header: this.customization.header,
            //             download: !this.permission.download,
            //             print: !this.permission.print,
            //             copyoutenabled: !this.permission.copyoutenabled,
            //         }
            //     });
            //     window.open(routeData.href, "_blank");
            // },
          onOpenNewEditor: function (type, sample = false) {
                this.fileExt = type;
                this.selectSample = sample;
                var query = {
                  key:null,//新建时key传空
                    mode: this.defaultConfig.mode,
                    fileExt: this.fileExt,
                    sample: this.selectSample,
                    userid: this.defaultConfig.userId,
                    name: this.defaultConfig.userName,
                    lang: this.defaultConfig.lang,
                }
                log("query in home", query)
                var routeData = this.$router.resolve({
                    path: "/editor",
                    query: query
                });
                window.open(routeData.href, "_blank");
                setTimeout(function () {
                    document.location.reload();
                }, 100)

            },
          propsDelete: function(name) {
                // log("delete home: ", name)
                // document.location.reload();
                // 从 data 中直接删除数据
                var index = this.fileLists.findIndex(e => e.name === name);
                if (index > -1) {
                    this.fileLists.splice(index, 1)[0];
                }
          },
          init: function () {
            var that = this;
            document.addEventListener("drop", function (e) {  //拖离
              e.preventDefault();
            });
            document.addEventListener("dragleave", function (e) {  //拖后放
              e.preventDefault();
            });
            document.addEventListener("dragenter", function (e) {  //拖进
              e.preventDefault();
            });
            document.addEventListener("dragover", function (e) {  //拖来拖去
              e.preventDefault();
            });
            var box = document.getElementById('fileupload'); //拖拽区域
            box.addEventListener("drop", function (e) {
              var fileList = e.dataTransfer.files;
              // console.log("上传的文件：", file)
              if (fileList[0]) {
                for (var i = 0; i < fileList.length; i++) {
                  that.handleUpload(fileList[i]);
                }

              }

            });
          }
    },


    }
</script>

<style scoped>
    body {
        margin: 20px;
        color: #333;
        font-family: 'PingFang SC', 'Microsoft Yahei', sans-serif;
        font-size: 16px;
    }
  .icon-desc {
    line-height: 24px;

  }
  .textExamples {
    width: 80%;
    margin: 0 auto;
  }
  .textContainer {
    grid-gap: 30px 0;
    display: grid;
    gap: 30px 0;
    grid-template-columns: repeat(3,1fr);
  }
  .text-center {
    background: #fff;
    border-radius: 6px;
    cursor: pointer;
    margin: 10px 20px;
    position: relative;
    width: 100%;
  }
  .box-title {
    color: #000;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .box-content {
    color: rgba(0,0,0,.7);
    font-size: 15px;
    line-height: 21px;
  }
  .box-bottom {
    border-radius: 6px;
    height: 200px;
    overflow: hidden;

    background: url('../assets/images/bg.png') no-repeat;
    background-size:100% 100%;
  }
  .box-bottom :hover {
    background-color: rgba(0, 0, 0, 0.4); /* 初始背景颜色为半透明 */
    transition: background-color 0.3s ease-in-out; /* 添加过渡效果 */
  }
  .box-bottom-content {
    align-items: center;
    /*background: #00000080;*/
    color: #fff;
    cursor: pointer;
    display: flex;
    inset: 0;
    justify-content: space-around;
    height: 100%;
    /*opacity: 0;
    position: absolute;
    transition: .4s;*/
  }
  .box-bottom-content /* 鼠标移入时蒙层样式 */
  :hover {
    background-color: rgba(0, 0, 0, 0.6); /* 鼠标移入时背景颜色变为更加不透明 */
  }
  .box-action {
    //font-size: 18px;
    padding: 6px;
    border-radius: 4px;
  }
  .readOnly {
    background-color: #f8d7da;
    color: #721c24;
    padding: 10px;
    text-align: center;
    //float: left;
    margin-bottom: 80px;
    font-size: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/views/home.vue